// 2020-06-27export { TropaSeguimientoListComponent } from './tropa-seguimiento-list.component';